<template>
  <b-sidebar id="add-new-user-sidebar" :visible="isAddNewUserSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{$t('survey.create')}}
        </h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">

          <!-- Full Name -->
          <validation-provider #default="validationContext" name="Survey Title" rules="required">
            <b-form-group :label="$t('survey.title')" label-for="Survey-name">
              <b-form-input id="full-name" v-model="userData.title" autofocus
                :state="getValidationState(validationContext)" trim :placeholder="$t('survey.placeholder.title')" />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Username -->
          <validation-provider #default="validationContext" name="Survey Code" rules="required">
            <b-form-group :label="$t('survey.code')" label-for="SurveyCode">
              <b-form-input id="SurveyCode" v-model="userData.surveyCode" :state="getValidationState(validationContext)"
                placeholder="SURVEY-2022-001" trim />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-group :label="$t('survey.type')" label-for="user-role"
            :state="!(userData.SurveyTypeId == null || userData.SurveyTypeId == 0)">
            <survey-type-picker :initialCategories="userData.SurveyTypeId" @selectionChanged="SurveyTypeUpdated" />

          </b-form-group>

          <!-- <b-form-group label="Survey Template" label-for="user-role"
            :state="!(userData.SurveyThemeId == null || userData.SurveyThemeId == 0)">
            <survey-theme-picker :initialCategories="userData.Surveymode" @selectionChanged="SurveyThemeUpdated" />

          </b-form-group> -->

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
              {{ $t("Add") }}
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
              @click="hide">
              {{ $t("Cancel") }}
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import SurveyTypePicker from '../components/SurveyTypePicker.vue'
import SurveyThemePicker from '../components/SurveyThemePicker.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SurveyTypePicker,
    SurveyThemePicker,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
    }
  },
  methods: {
    SurveyTypeUpdated(payload) {
      //console.log("Catefy result in info ");
      //console.log(payload);
      if (payload == null) {
        this.userData.SurveyTypeId = 0;

        this.userData.surveyType = null,
          this.userData.surveyTypeKey = null
      } else {
        this.userData.SurveyTypeId = payload.id;

        this.userData.surveyType = payload.title,
          this.userData.surveyTypeKey = payload.typekey
      }

    },
    SurveyThemeUpdated(payload) {
      //console.log("Catefy result in info ");
      //console.log(payload);
      if (payload == null) {
        this.userData.SurveyTypeId = payload.id;

        this.userData.surveyType = payload.title,
          this.userData.surveyTypeKey = payload.typekey
      } else {
        this.userData.SurveyThemeId = payload.id;

        this.userData.surveyThemeText = payload.title,
          this.userData.surveyThemeKey = payload.typekey
      }
    },
  },
  setup(props, { emit }) {
    const blankUserData = {
      title: '',
      SurveyCode: '',
      Surveymode: '',
    }

    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }

    const onSubmit = () => {
      //console.log("Survey ADD PAGE  Create triggered");
      store.dispatch('app-surveys/addSurvey', userData.value)
        .then(() => {

          emit('refetch-data')
          emit('new-record-created')
          emit('update:is-add-new-user-sidebar-active', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
